<fieldset class="openforms-fieldset {% if (ctx.component.hideHeader) { %}openforms-fieldset--no-header{% } %}">
  {% if (ctx.component.label && !ctx.component.hideHeader) { %}
  <legend ref="header" class="openforms-fieldset__legend">
    {{ctx.t(ctx.component.label, { _userInput: true })}}
    {% if (ctx.component.tooltip) { %}
      <i ref="tooltip" class="{{ctx.iconClass('question-sign')}} text-muted" data-tooltip="{{ctx.component.tooltip}}"></i>
    {% } %}
  </legend>
  {% } %}
  {% if (!ctx.collapsed) { %}
  <div class="openforms-form-field-container" ref="{{ctx.nestedKey}}">
    {{ctx.children}}
  </div>
  {% } %}
</fieldset>
